// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../public/images/resized/hero-image-small.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media screen and (max-width: 576px) {
    .nav {
        display: none;
    }
    .drawer_resp {
		z-index: 10;
		background-color: #445069;
		width: 100%;
		position: fixed;
		-webkit-transform: translate(-100%, 0);
		transform: translate(-100%, 0);
		transition: transform 0.3s ease;
	}
    .open {
        -webkit-transform: translate(0, 0);
        transform: translate(0, 0);
    }
    .drawer_item {
        display: list-item;
        color: black !important;
        width: 100%;
        text-align: left;
    }
    .hamburger a {
        display: inline-block;
        font-size: 30px;
        text-decoration: none;
        color: #F7E987 !important;
        font-family: 'Pacifico', cursive;
    }
    .content__heading {
        text-align: center;
        margin-bottom: 20px;
    }
    .hero {
        background: linear-gradient(rgba(0, 0, 5, .5), rgba(0, 0, 5, .5)), url(${___CSS_LOADER_URL_REPLACEMENT_0___}) repeat center;
    }
    .hero_title {
        font-size: 56px;
    }
    .hero_tagline1 {
        font-size: 30px;
    }
    .hero_tagline2 {
        font-size: 24px;
    }
}

@media screen and (max-width: 649px) {
    .submitReview {
        display: flex;
        justify-content: center;
        align-items: center;
    }
}

@media screen and (min-width: 576px) {
    .hamburger {
        display: none;
    }
    .drawer_resp {
        display: none;
    }
}


@media screen and (min-width: 650px) {
    .list-item__content {
        padding: 16px 32px 32px 32px;
    }
    .list-item__title {
        font-size: 18px;
    }
    .list-item__description {
        font-size: 14px;
    }
    .restaurant-review {
        padding: 10px 20px;
    }  
    .form-group {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
}

@media screen and (max-width: 700px) {
    .restaurant-menu h3 {
        text-align: left;
        margin: 10px;
    }
    .detailRestaurant-info {
        display: flex;
        flex-direction: column;
        align-items: center;
    }
}

@media screen and (min-width: 700px) {
    .lists {
        display: grid;
        grid-template-columns: 1fr 1fr;
        grid-column-gap: 10px;
        grid-row-gap: 16px;
    }
    .restaurant-menu {
        display: grid;
        grid-template-columns: 1fr 1fr;
        grid-column-gap: 10px;
        grid-row-gap: 16px;
    }
}

@media screen and (min-width: 800px) {
    .nav_list {
        max-width: 800px;
        margin: 0 auto;
    }
}

@media screen and (min-width: 900px) {
    .lists {
        display: grid;
        grid-template-columns: 1fr 1fr 1fr;
    }
    .restaurant-menu {
        display: grid;
        grid-template-columns: 1fr 1fr;
        grid-column-gap: 10px;
        grid-row-gap: 16px;
    }
}

@media screen and (min-width: 1200px) {
    main {
        max-width: 1200px;
    }   
}`, "",{"version":3,"sources":["webpack://./src/styles/responsive.css"],"names":[],"mappings":"AAAA;IACI;QACI,aAAa;IACjB;IACA;EACF,WAAW;EACX,yBAAyB;EACzB,WAAW;EACX,eAAe;EACf,sCAAsC;EACtC,8BAA8B;EAC9B,+BAA+B;CAChC;IACG;QACI,kCAAkC;QAClC,0BAA0B;IAC9B;IACA;QACI,kBAAkB;QAClB,uBAAuB;QACvB,WAAW;QACX,gBAAgB;IACpB;IACA;QACI,qBAAqB;QACrB,eAAe;QACf,qBAAqB;QACrB,yBAAyB;QACzB,gCAAgC;IACpC;IACA;QACI,kBAAkB;QAClB,mBAAmB;IACvB;IACA;QACI,wHAAqI;IACzI;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,aAAa;QACb,uBAAuB;QACvB,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;IACA;QACI,aAAa;IACjB;AACJ;;;AAGA;IACI;QACI,4BAA4B;IAChC;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,kBAAkB;IACtB;IACA;QACI,aAAa;QACb,8BAA8B;QAC9B,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,gBAAgB;QAChB,YAAY;IAChB;IACA;QACI,aAAa;QACb,sBAAsB;QACtB,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,aAAa;QACb,8BAA8B;QAC9B,qBAAqB;QACrB,kBAAkB;IACtB;IACA;QACI,aAAa;QACb,8BAA8B;QAC9B,qBAAqB;QACrB,kBAAkB;IACtB;AACJ;;AAEA;IACI;QACI,gBAAgB;QAChB,cAAc;IAClB;AACJ;;AAEA;IACI;QACI,aAAa;QACb,kCAAkC;IACtC;IACA;QACI,aAAa;QACb,8BAA8B;QAC9B,qBAAqB;QACrB,kBAAkB;IACtB;AACJ;;AAEA;IACI;QACI,iBAAiB;IACrB;AACJ","sourcesContent":["@media screen and (max-width: 576px) {\n    .nav {\n        display: none;\n    }\n    .drawer_resp {\n\t\tz-index: 10;\n\t\tbackground-color: #445069;\n\t\twidth: 100%;\n\t\tposition: fixed;\n\t\t-webkit-transform: translate(-100%, 0);\n\t\ttransform: translate(-100%, 0);\n\t\ttransition: transform 0.3s ease;\n\t}\n    .open {\n        -webkit-transform: translate(0, 0);\n        transform: translate(0, 0);\n    }\n    .drawer_item {\n        display: list-item;\n        color: black !important;\n        width: 100%;\n        text-align: left;\n    }\n    .hamburger a {\n        display: inline-block;\n        font-size: 30px;\n        text-decoration: none;\n        color: #F7E987 !important;\n        font-family: 'Pacifico', cursive;\n    }\n    .content__heading {\n        text-align: center;\n        margin-bottom: 20px;\n    }\n    .hero {\n        background: linear-gradient(rgba(0, 0, 5, .5), rgba(0, 0, 5, .5)), url(\"../public/images/resized/hero-image-small.jpg\") repeat center;\n    }\n    .hero_title {\n        font-size: 56px;\n    }\n    .hero_tagline1 {\n        font-size: 30px;\n    }\n    .hero_tagline2 {\n        font-size: 24px;\n    }\n}\n\n@media screen and (max-width: 649px) {\n    .submitReview {\n        display: flex;\n        justify-content: center;\n        align-items: center;\n    }\n}\n\n@media screen and (min-width: 576px) {\n    .hamburger {\n        display: none;\n    }\n    .drawer_resp {\n        display: none;\n    }\n}\n\n\n@media screen and (min-width: 650px) {\n    .list-item__content {\n        padding: 16px 32px 32px 32px;\n    }\n    .list-item__title {\n        font-size: 18px;\n    }\n    .list-item__description {\n        font-size: 14px;\n    }\n    .restaurant-review {\n        padding: 10px 20px;\n    }  \n    .form-group {\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n    }\n}\n\n@media screen and (max-width: 700px) {\n    .restaurant-menu h3 {\n        text-align: left;\n        margin: 10px;\n    }\n    .detailRestaurant-info {\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n    }\n}\n\n@media screen and (min-width: 700px) {\n    .lists {\n        display: grid;\n        grid-template-columns: 1fr 1fr;\n        grid-column-gap: 10px;\n        grid-row-gap: 16px;\n    }\n    .restaurant-menu {\n        display: grid;\n        grid-template-columns: 1fr 1fr;\n        grid-column-gap: 10px;\n        grid-row-gap: 16px;\n    }\n}\n\n@media screen and (min-width: 800px) {\n    .nav_list {\n        max-width: 800px;\n        margin: 0 auto;\n    }\n}\n\n@media screen and (min-width: 900px) {\n    .lists {\n        display: grid;\n        grid-template-columns: 1fr 1fr 1fr;\n    }\n    .restaurant-menu {\n        display: grid;\n        grid-template-columns: 1fr 1fr;\n        grid-column-gap: 10px;\n        grid-row-gap: 16px;\n    }\n}\n\n@media screen and (min-width: 1200px) {\n    main {\n        max-width: 1200px;\n    }   \n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
